/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Codes_TakenInputs */

const en_issue_codes_taken = /** @type {(inputs: Issue_Codes_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`another product already has these codes`)
};

/**
* | output |
* | --- |
* | "another product already has these codes" |
*
* @param {Issue_Codes_TakenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_codes_taken = /** @type {((inputs?: Issue_Codes_TakenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Codes_TakenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_codes_taken(inputs)
});